import {CourseVariation, CourseVariant, VariantCourse} from '@/types/course';
import {CourseVariationType} from '@udemy-v2/graphql';

export const VALUE_DELIMITER = '#';

export interface VariationCombination {
    id: string;
    type: CourseVariationType;
    course: VariantCourse;
}

export const getCourseVariationsCombinations = (variations: CourseVariation[]) => {
    const combinationsOfVariations: Map<string, VariationCombination> = new Map();

    if (variations.length == 1) {
        variations[0].variants.forEach((variant) => {
            const id = `${variations[0].type}${VALUE_DELIMITER}${variant.option.id.trim()}`;
            combinationsOfVariations.set(id, {
                id,
                type: variations[0].type,
                course: variant.course,
            });
        });
    } else if (variations.length >= 2) {
        variations[0].variants.forEach((variant) => {
            variations[1].variants.forEach((variant2) => {
                if (variant.course.id !== variant2.course.id) {
                    return;
                }
                const id = `${variations[0].type}${VALUE_DELIMITER}${variant.option.id.trim()}${VALUE_DELIMITER}${variations[1].type}${VALUE_DELIMITER}${variant2.option.id.trim()}`;
                combinationsOfVariations.set(id, {
                    id,
                    type: variations[0].type,
                    course: variant2.course,
                });
            });
        });
    }
    return combinationsOfVariations;
};

// Helper function to sort course variants, moves current course variant type to the start of the listing.
export const variantSortHelper = (a: CourseVariant, b: CourseVariant, courseId: string) => {
    if (b.course.id === courseId) {
        return 1;
    }
    if (a.course.id === courseId) {
        return -1;
    }
    return 0;
};
